import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const apiKey = process.env.REACT_APP_API_BASE_API_KEY;
const ACCESS_TOKEN = JSON.parse(localStorage.getItem('userInfo') ?? '{}')?.access;

const config = {
  headers: {
    "Content-Type": "application/json",
    "Api-Key": apiKey,
    Authorization: `Bearer ${ACCESS_TOKEN}`,
  },
};

const ClientService = {
  createClient: async (formData) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/client/clients/`, formData, config
      );
      return response;
    } catch (error) {
      console.log('Error messages:', error);
    }
  },

  // Add more API functions as needed
};

export default ClientService;
